import React, { Component } from 'react';
import { Button } from 'reactstrap';
import withBackgroundImage from '../../HOC/withBackgroundImage';

import './Error.scss';

class TimeOutContainer extends Component {
  render() {
    return (
      <div className="error-page">
        <h1>Oops, something went wrong on our end.</h1>
        <p className="heading">It looks like we've encountered a problem and can't display your Visa application. We're sorry for the inconvenience. Please check back later.</p>

        <div className="button-background">       
          <Button color="primary" size="lg" href="https://www.vancity.com">Go to vancity.com</Button>      
        </div>
      </div>
    );
  }
}



export default withBackgroundImage("error")(TimeOutContainer);


// WEBPACK FOOTER //
// ./src/containers/Error/Error.js